export default {
  navigationBarTitleText: '历史修改记录'
};
